export default {
    product: {
        description: {
            more: "更多的"
        },
        added: "已添加到购物车"
    }
}